import styled from 'styled-components';
import {MainScreenDefaultBox} from './main-screen.default.box';
import {Color} from '../../../themes/definitions/harrahs/harrahs-colors';


export const MainScreenHarrahsBox = styled(MainScreenDefaultBox)`
    background-attachment: fixed;
    background: radial-gradient(ellipse at center, ${Color.light_black} 0%, ${Color.black} 100%);
`;